<template>
    <div v-if="isAD" class="row">
        <div class="col" v-if="selectedRepairOptionDetails && hasOptionSelected">
            <hr />
            <i class="fas fa-info-circle mr-2"></i> Repair option has already been selected for this gadget.
        </div>
        <div v-else class="col">
            <div class=" float-right">
                <button class="btn btn-primary btn-sm" @click="handlePreviewOptionsForGadgetClick"><i class="fas fa-cogs"></i> Configure R/R options</button>
            </div>
        </div>
        <b-modal :id="_uid + 'gadget-options-modal'" size="lg" hide-footer>
            <template slot="modal-title">
                Preview
            </template>
            <div v-if="!optionsPreviewForGadget" class="d-flex justify-content-center">
                <spinner height="50px" width="50px" />
            </div>
            <div v-else>
                <h2>System configured options</h2>
                <p><i class="fas fa-info-circle mr-2"></i> These are the options that the customer will see.</p>
                <br />

                <div class="claim-list-card"
                     :class="index > 0 ? 'mt-2' : ''"
                     v-for="(option, index) in optionsPreviewForGadget.availableOptions"
                     :key="index">
                    <div class="row claim-list-card-body">
                        <div class="col-sm-3 text-center">
                            <i v-bind:class="option.repairOptionWebDisplayIcon"
                               style="font-size: 32px;">
                            </i>
                        </div>
                        <div class="col border-right border-left">
                            <p>{{option.repairOptionWebDisplayTitle}} ({{option.repairProviderLabel}})</p>
                            <p class="font-italic">{{optionMauallySet(option)}}</p>
                        </div>
                        <div class="col-3 border-right border-left">
                            <button class="ml-5 btn btn-danger btn-sm"
                                    @click="handleDelOptionClick(option)">
                                Remove
                            </button>
                        </div>
                    </div>
                </div>
                <span v-if="!optionsPreviewForGadget.availableOptions">
                    No options configured.
                </span>
                <hr />
                <b-card no-body>
                    <b-tabs card>
                        <b-tab title="Preconfig options" active>
                            <div>
                                <div class="form-inline">
                                    <label class="sr-only" for="newOption">Option</label>
                                    <select id="newTemplate" class="form-control form-control-sm mb-2 mr-sm-4" v-model="newOption">
                                        <option :value="null" disabled>Select a option...</option>
                                        <option v-for="type in manDeviceRepairPreConfigItems" v-bind:value="type">
                                            {{ type.label }}
                                        </option>
                                    </select>
                                    <button class="btn btn-sm btn-primary mb-2" @click="handleAddOptionPreConfigClick">Add Option</button>
                                </div>
                                <br />
                                <label class="form-check-label">
                                    <input type="checkbox"
                                           class="form-check-input mb-2"
                                           value="">
                                    Replace the above options (if not selected then option will be added)
                                </label>
                            </div>
                        </b-tab>
                    </b-tabs>
                </b-card>
            </div>
        </b-modal>

    </div>
</template>

<script>

import { mapActions } from 'vuex'
import spinner from '@/components/spinner.vue'

export default {
  name: 'GadgetOptions',
        props: {
            gadgetWebReference: { type : String, required: true }
        },
        mixins: [
            
        ],
  components: {
      spinner
  },

  data: () => {
      return {
          newType: null,
          newProvider: null,
          newDisplay: null,
          newTemplate: null,
          newOption: null
    }
  },
  computed: {
    selectedClaim() {
        return this.$store.getters.selectedClaim
    },
      isAD() {
        return true
        //return this.selectedClaim.parentId == 1000
    },
    isMB() {
        return this.selectedClaim.parentId == 1003
    },
    isLoading() {
        return this.$store.getters.isLoading
    },
    optionsPreviewForGadget() {
        return this.$store.getters.gadgetOptionsPreview
    },
    repairProviders() {
        return this.$store.getters.repairProviders
    },
    repairOptionTypes() {
        return this.$store.getters.repairOptionTypes
    },
    repairOptionWebDisplay() {
        return this.$store.getters.repairOptionWebDisplay
    },
    emailTemplates() {
        return this.$store.getters.emailTemplates
    },
    manDeviceRepairPreConfigItems() {
        return this.$store.getters.manDeviceRepairPreConfigItems
      },
      manRROptionsParams() {
          let { resellerId, incidentDetails } = this.selectedClaim
      
          let { incidentTypeId } = incidentDetails

          let gadget = this.selectedClaim.gadgetDetails.find(g => g.webreference = this.gadgetWebReference)
          let { typeId, makeId } = gadget

          return {
              resellerId,
              incidentTypeId,
              deviceTypeId: typeId,
              deviceMakeId: makeId
          }
      },
    gadgetId() {
        let gadget = this.selectedClaim.gadgetDetails.find(g => g.webreference = this.gadgetWebReference)

        if (gadget) {
            return gadget.id
        }

        return null
      },
      selectedRepairOptionDetails() {
          return this.selectedClaim.selectedRepairOptionDetails
      },
      selectedRepairOptionHistoryForGadget() {
          return this.selectedRepairOptionDetails.filter(e => { return e.gadgetId == this.gadgetId; })
      },
      selectedRepairOptionForGadget() {
          let mostRecentObject = null
          try {
              let mostRecentDate = new Date(Math.max.apply(null, this.selectedRepairOptionHistoryForGadget.map(e => {
                  return new Date(e.dateCreated);
              })));
              console.log('mostRecentDate:', mostRecentDate)
              if (mostRecentDate != null) {
                  mostRecentObject = this.selectedRepairOptionHistoryForGadget.filter(e => {
                      var d = new Date(e.dateCreated);
                      return d.getTime() == mostRecentDate.getTime();
                  })[0];
              }
          }
          catch (err) {
              console.log('selectedRepairOptionForGadget: ' , err)
          }
          return mostRecentObject
      },
      hasOptionSelected() {
          let { selectedRepairOptionForGadget } = this
          if (selectedRepairOptionForGadget) {
              if (selectedRepairOptionForGadget.dateCancelled) {
                  return false
              } else {
                  return true
              }
          }
          return false
      }
},
  mounted() {
      
  },
  watch: {

  },
methods: {
    ...mapActions([
        'fetchOptionsPreviewForGadget',
        'resetOptionsPreviewForGadget',
        'fetchRepairProviders',
        'fetchRepairOptionTypes',
        'fetchRepairOptionWebDisplay',
        'fetchEmailTemplates',
        'addManualOptionForGadget',
        'fetchManDeviceRepairPreConfigItems',
        'addManualOptionForGadgetFromPreConfig',
        'delManualOption',
        'addManualOptionForGadgetFromSys'
    ]),
    handlePreviewOptionsForGadgetClick() {
        this.fetchOptionsPreviewForGadget(this.gadgetWebReference)
        this.fetchManDeviceRepairPreConfigItems(this.manRROptionsParams)
        //this.fetchRepairOptionTypes()
        //this.fetchRepairProviders()
        //this.fetchRepairOptionWebDisplay()
        //this.fetchEmailTemplates()

        this.$bvModal.show(this._uid + 'gadget-options-modal')
    },
    handleAddOptionClick() {
        let {
            newType: {
                id: repairOptionTypeId
            },
            newProvider: {
                id: repairProviderId
            },
            newDisplay: {
                id: repairOptionWebDisplayId
            },
            newTemplate: {
                id: emailTemplateId
            },
            gadgetId,
            gadgetWebReference
        } = this

        this.addManualOptionForGadget({ gadgetWebReference, gadgetId, repairOptionTypeId, repairProviderId, repairOptionWebDisplayId, emailTemplateId })

        this.resetValues()
    },
    handleAddOptionPreConfigClick() {
        let {
            newOption: {
                id: preConfigId
            },
            gadgetId,
            gadgetWebReference
        } = this
        this.addManualOptionForGadgetFromPreConfig({ gadgetWebReference, gadgetId, preConfigId })

        this.resetValues()
    },
    handleDelOptionClick(option) {
        console.log('handleDelOptionClick: ', option)
        let { gadgetId, gadgetWebReference } = this

        let { id, setManually } = option
        if (setManually == false) {
            let copyOpts = this.optionsPreviewForGadget.availableOptions.filter(o => o.id != id)
            let payload = { gadgetWebReference, gadgetId, optionIds: copyOpts.map(o => { return o.id }) }
            console.log('payload: ', payload)
            this.addManualOptionForGadgetFromSys(payload)
        } else {
            console.log('payload: ', { optionId: option.id, gadgetWebReference })
            this.delManualOption({ optionId: option.id, gadgetWebReference })
        }
    },
    resetValues() {
        this.newType = null
        this.newProvider = null
        this.newDisplay = null
        this.newTemplate = null
        this.newOption = null
    },
    optionMauallySet(option) {
        if (option) {
            if (option.setManually) {
                return 'Manually set option for this gadget!'
            } else {
                return 'System generated option for this gadget!'
            }
        }
    }
  }
}
</script>

